export default __webpack_public_path__ + "static/media/028-toaster.15a03aac.svg";